import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[AddressValidator]'
})
export class AddressValidatorDirective {

  private regex: RegExp = new RegExp(/^[0-9]+[ a-zA-Z\.0-9]*$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Decimal', 'Del', 'Delete', 'Left', 'Right', 'ArrowLeft', 'ArrowRight'];

  constructor(private el: ElementRef) { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    let next: string = event.key;

    if (current) {
      
      let firstPart = current.substr(0, this.el.nativeElement.selectionStart);
      let secondPart = current.substr(this.el.nativeElement.selectionStart + (this.el.nativeElement.selectionEnd - this.el.nativeElement.selectionStart), current.length - 1);

      next = firstPart + next + secondPart;

    } 

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/AddressValidator/AddressValidatorDirective.ts